import React, { useState } from 'react';
import { Form, Input, Button, Typography, notification } from 'antd';
import { UserOutlined, LockOutlined, ArrowRightOutlined } from '@ant-design/icons';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import { MAINAPIURL, CUSTOMERNAME } from '../appsettings';
import { tokenService } from '../../services/tokenService';
import AuthLayout from './AuthLayout';

const { Text } = Typography;

const MemberLogin = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const onFinish = async (values) => {
        setLoading(true);
        try {
            const response = await axios.post(`${MAINAPIURL}/portal/login.php`, {
                member_id: values.member_id,
                password: values.password
            });

            if (response.data.status === 'success') {
                tokenService.setAccessToken(response.data.access_token);
                localStorage.setItem("USERID", response.data.userid);
                localStorage.setItem("USERDPNAME", response.data.displayname);
                localStorage.setItem("USERROLE", response.data.userrole);
                notification.success({
                    message: 'Welcome Back!',
                    description: `Redirecting to ${CUSTOMERNAME} dashboard...`,
                    placement: 'top'
                });
                setTimeout(() => navigate('/dash'), 1200);
            } else {
                notification.error({
                    message: 'Login Failed',
                    description: response.data.message || "Invalid credentials.",
                    placement: 'top'
                });
            }
        } catch (error) {
            notification.error({
                message: 'Connection Error',
                description: "Unable to reach the server. Please check your connection.",
                placement: 'top'
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <AuthLayout 
            title="Welcome Back" 
            subtitle={`Sign in to your ${CUSTOMERNAME} portal`}
        >
            <Form
                layout="vertical"
                onFinish={onFinish}
                requiredMark={false}
                size="large"
                className="clean-login-form"
            >
                <Form.Item
                    name="member_id"
                    label={<Text style={{ color: '#555', fontSize: 13, fontWeight: 500 }}>Member ID</Text>}
                    rules={[{ required: true, message: 'Please enter your Member ID' }]}
                >
                    <Input 
                        prefix={<UserOutlined style={{ color: '#209c96', marginRight: 6 }} />} 
                        placeholder="Enter your ID" 
                        style={{ 
                            borderRadius: 12, 
                            padding: '12px 14px',
                            border: '1.5px solid #e8ecf0',
                            fontSize: 15
                        }}
                    />
                </Form.Item>

                <Form.Item
                    name="password"
                    label={<Text style={{ color: '#555', fontSize: 13, fontWeight: 500 }}>Password</Text>}
                    rules={[{ required: true, message: 'Please enter your password' }]}
                >
                    <Input.Password 
                        prefix={<LockOutlined style={{ color: '#209c96', marginRight: 6 }} />} 
                        placeholder="••••••••" 
                        style={{ 
                            borderRadius: 12, 
                            padding: '12px 14px',
                            border: '1.5px solid #e8ecf0',
                            fontSize: 15
                        }}
                    />
                </Form.Item>

                <Form.Item style={{ marginTop: 28, marginBottom: 0 }}>
                    <Button
                        type="primary"
                        htmlType="submit"
                        loading={loading}
                        block
                        style={{
                            height: 50,
                            borderRadius: 12,
                            fontSize: 15,
                            fontWeight: 600,
                            background: '#209c96',
                            border: 'none',
                            boxShadow: '0 4px 14px rgba(32,156,150,0.25)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: 8,
                            transition: 'all 0.2s ease'
                        }}
                        className="login-submit-btn"
                    >
                        Sign In <ArrowRightOutlined />
                    </Button>
                </Form.Item>

                <div style={{ textAlign: 'center', marginTop: 16 }}>
                    <Link to="/reset-password" style={{ color: '#209c96', fontWeight: 500 }}>
                        Forgot Password?
                    </Link>
                </div>
            </Form>

            <style>{`
                .clean-login-form .ant-input-affix-wrapper {
                    border-radius: 12px !important;
                    border: 1.5px solid #e8ecf0 !important;
                    transition: all 0.2s ease !important;
                }
                .clean-login-form .ant-input-affix-wrapper:hover {
                    border-color: #209c96 !important;
                }
                .clean-login-form .ant-input-affix-wrapper-focused {
                    border-color: #209c96 !important;
                    box-shadow: 0 0 0 3px rgba(32,156,150,0.08) !important;
                }
                .login-submit-btn:hover {
                    background: #1a8a85 !important;
                    box-shadow: 0 6px 20px rgba(32,156,150,0.3) !important;
                    transform: translateY(-1px) !important;
                }
            `}</style>
        </AuthLayout>
    );
};

export default MemberLogin;
